<template>
  <section class="mx-10">
    <v-card>
      <v-progress-linear
        v-if="loading"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template v-else>
        <v-card-text>
          <v-row justify="end">
            <v-col>
              <h2 class="py-4">
                Дүйцүүлэлт баталгаажуулаx
                <span v-if="scoresTobeConfirmed"
                  >({{ scoresTobeConfirmed.length }})</span
                >
              </h2>
            </v-col>
          </v-row>
          <template v-if="scoresTobeConfirmed">
            <v-data-table
              :headers="headers"
              :items="scoresTobeConfirmed"
              :search="search"
            >
              <template v-slot:item.actions="{ item }">
              
                <v-btn small @click="doConfirm(item)" elevation="0" color="secondary"> Баталгаажуулаx </v-btn>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </template>
    </v-card>
  </section>
</template>

<script>
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  data() {
    return {
      headers: [
        { text: "index", value: "index" },
        { text: "Оюутны нэр", value: "name2" },
        { text: "Оюутны код", value: "studentCode" },
        { text: "Xичээлийн нэр", value: "newLessonComparedData.selectedLessonStandard.name" },
        { text: "Xичээлийн код", value: "lessonCode" },
        { text: "Семестер", value: "semesterName" },
        { text: "Дүйцүүлсэн xичээлийн нэр", value: "newLessonComparedData.name" },
        { text: "Кредит зөрөө", value: "newLessonComparedData.creditDifference" },
        { text: "Эцсийн дүн", value: "scoreTotal" },
        { text: "Үйлдэл", value: "actions" },
      ],
      search: "",
      loading: false,
      scoresTobeConfirmed: null,
    };
  },
  components: {
    ...mapState(["userProfile", "currentUser"]),
  },
  computed: {},
  watch: {
    searchWord(val) {},
  },
  methods: {
    async doConfirm(score) {
      var yes = confirm("Дүнг баталгаажуулаx уу?");
      if (yes) {
        var xx = await fb.db.doc(score.originalScoreDocumentPath).get();
        var xxData = xx.data();
        xxData.newLessonComparedData.confirmedByAdmissionDepartment = true;
        xxData.confirmedByAdmissionDepartment = true;
        xx.ref.update(xxData).then(() => {
          score.ref.delete().then(() => {
          });
        });
      }
    },
  },
  created() {
    fb.db
      .collection("/schools/YJHjHWUGDok8teDhDIKX/_allScoresTobeConfirmed")
      .onSnapshot((docs) => {
        this.scoresTobeConfirmed = [];
        var counter = 0;
        docs.forEach((doc) => {
          counter++;
          let score = doc.data();
          score.ref = doc.ref;
          score.id = doc.id;
          score.index = counter;
          score.name2 = score.lastName&&score.lastName.length>0?score.lastName[0]+score.firstName?score.firstName:"N/A":""
          score.lessonName = 
          this.scoresTobeConfirmed.push(score);
        });
      });
  },
};
</script>